module.exports = __webpack_public_path__ + "static/media/happy.9e446e87.svg";